<template>
  <div>
    <div class="todo-nav nav-bar-item ml12" @click="drawerHandler">
      <i class="icon BLM-icon-news"></i>
      <!-- <svg-icon icon-class="todo-count" class="icon"  /> -->
      <span>我的待办</span>
      <span class="todo-nav-num" v-if="todoCount && todoCount != 0">
        {{ todoCount && todoCount > 99 ? '+99' : todoCount }}
      </span>
    </div>
    <newTodoDrawer
      v-if="judgePermission('workbench_get_deal_with_list_button')"
      :drawerVisible="drawerObj.visible"
      @close="drawerObj.visible = false"
    />
    <todo-drawer
      v-else
      :drawerVisible="drawerObj.visible"
      @close="drawerObj.visible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import todoDrawer from './todo/todoDrawer.vue'
import newTodoDrawer from '@/pages/workbench/todo/components/todoDrawer.vue'

export default {
  components: {
    newTodoDrawer,
    todoDrawer,
  },
  data() {
    return {
      drawerObj: {
        visible: false,
      },
    }
  },
  computed: {
    ...mapGetters(['todoCount']),
  },
  methods: {
    drawerHandler() {
      this.drawerObj.visible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-nav {
  position: relative;

  .todo-nav-num {
    transform: scale(0.75, 0.75);
    cursor: pointer;
    position: absolute;
    top: -8px;
    right: -15px;
    width: 26px;
    height: 26px;
    line-height: 26px;
    border-radius: 50%;
    background: #ff4d88;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
  }
}
</style>
